var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as FinalFormAction from './actions/form_final.actions';
var defaultState = {
    formulario: '',
    tipo_solicitud: '',
    tipo_recepcion: '',
    propiedad: '',
    propietarios: '',
    representantes: '',
    arquitectos: '',
    empresas: '',
    constructores: '',
    constructora: '',
    independiente: '',
    informe: '',
    declaracion: '',
    permiso_notariado: '',
    cip: '',
    proyecto: '',
    plazo: '',
    antecedentes: '',
    caracteristica_proyecto: '',
    datos_proyecto: '',
    antecedentes_edif: '',
    anteproy_condominio: '',
    autorizaciones: '',
    clasificacion: '',
    condiciones: '',
    disposicion: '',
    disposiciones_esp: '',
    normas_urbanisticas: '',
    recepcion: '',
    recepcion_parcial: '',
    registro_bienes: '',
    superficie: '',
    superficie_anteproyecto: '',
    unidades: '',
    uso_publico: '',
    ampliacion: '',
    archivos: '',
    Permisos: '',
    permisos_recep: '',
    permisos_recepciones: '',
    idusuario_mongo: ''
};
var newState = function (state, newData) {
    return Object.assign({}, state, newData);
};
var ɵ0 = newState;
export function finalFormReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case FinalFormAction.CREATE_FORM:
            return newState(state, __assign({}, action.newFormValues));
        default:
            return state;
    }
}
export { ɵ0 };
